/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import classNames from 'classnames/bind';
import { connect, ConnectedProps } from 'react-redux';
import Text from '../../atoms/Text';
import CrossIcon from '../../atoms/Icon/CrossIcon';
import Button from '../../atoms/button';
import Image from '../../atoms/ImageView';
import RotatingText from '../RotatingText';
import { Feature, Variant } from '../ABFeature';
import properties from '../../../modules/ajio-util/properties';
import { gtmEventPush } from '../../../modules/ga/GTMdatalayer';
import { getAppInstallFlag, getAppConfig, getAppsFlyerConfig } from '../../selectors/featureFlagsSelector';
import { getSisFlag } from '../../selectors/metaData';
import { triggerApp, handleCloseBanner, checkNewUser, isMicroApp } from './utils';
import useAppInstall from './useAppInstall';
const BarCarousel = React.lazy(() => import('../../atoms/BarCarousel'));
import {replaceWithJioCDN} from '../../../../src/utils/imageHandling'
import styles from './appinstall.module.pcss';

const cx = classNames.bind(styles);
const imgPath = `${properties.getProperty('imageBaseUrl')}/static/img`;

const mapStateToProps = (state: import('../../types/rootState').RootState) => ({
  appInstallFeature: getAppInstallFlag(state),
  appConfig: getAppConfig(state),
  sisFlag: getSisFlag(state),
  appsFlyerConfig: getAppsFlyerConfig(state?.flags)
});

const connector = connect(mapStateToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

const StickyBanner = ({
  id = '',
  pagetype,
  appInstallFeature = {},
  setBannerClosed,
  appConfig,
  containerClass,
  sisFlag,
  appsFlyerConfig,
  origin
}: PropsFromRedux): Element.JSX => {
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
  let utmSource = searchParams.get('utm_source') || '';
  if (utmSource !== '') {
    sessionStorage.setItem('utmSource', utmSource);
  } else {
    utmSource = sessionStorage.getItem('utmSource') || '';
  }
  const isUtmBrowser = utmSource === 'Browser';
  const isAppInstall = useAppInstall();
  const { stickyBanner = {}, dynamicAppInstallBanners = "OFF", carouselBanner = [] } = appInstallFeature;
  console.log("APP INSTALL FEATURE", appInstallFeature)
  const {
    image,
    newUserHeaderText,
    oldUserHeaderText,
    newUserSubtexts,
    oldUserSubtexts
  } = stickyBanner;
  const itemInitialState = sessionStorage.getItem('bannerClosed') !== 'true';
  const [visibility, setVisibility] = useState(itemInitialState);
  const handleClose = (): void => {
    setVisibility(false);
    handleCloseBanner();
    setBannerClosed && setBannerClosed(true);
    gtmEventPush({
      event: 'app_install_widget_interaction',
      category: 'widget interaction',
      action: 'app install widget interaction',
      label: 'close'
    });
  };
  const doNotRender =
    appInstallFeature[pagetype] !== 'ON' || !visibility || sisFlag || isMicroApp() || isUtmBrowser;
  const impressionId = pagetype === 'homepage' && id === 'homepageBanner' ? 'impression_app-install' : '';

  const onScroll = () => {
    let imresssionId;
    if (impressionId && impressionId.trim() !== '') {
      imresssionId = document.querySelector(`.${impressionId}`);
    }

    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting && entry.intersectionRatio > 0.5) {
          const impressionFired = JSON.parse(localStorage.getItem(`${impressionId}`)) ?? false;
          if (!impressionFired) {
            localStorage.setItem(impressionId, JSON.stringify(true));

            gtmEventPush({
              event: 'app_install_widget_impression',
              category: 'widget interaction',
              action: 'app install widget impresssion',
              label: pagetype === 'homepage' ? 'header' : pagetype
            });
          }
        }
      });
    });

    if (imresssionId) {
      observer.observe(imresssionId);
    }
  };

  // useEffect(() => {
  //   if (!doNotRender) {
  //     gtmEventPush({
  //       event: 'app_install_widget_impression',
  //       category: 'widget interaction',
  //       action: 'app install widget impresssion',
  //       label: pagetype === 'homepage' ? 'header' : pagetype
  //     });
  //   }
  // }, []);

  useEffect(() => {
    window.addEventListener('scroll', onScroll);
    window.addEventListener('beforeunload', () => {
      localStorage.removeItem(impressionId);
    });

    return () => {
      window.removeEventListener('beforeunload', () => {
        localStorage.removeItem(impressionId);
      });
      window.removeEventListener('scroll', () => { });
    };
  }, []);

  if (doNotRender) {
    return null;
  }

  const isNewUser = checkNewUser();
  const subtexts = isNewUser ? newUserSubtexts : oldUserSubtexts;
  return (
    <Feature featureName="appInstall">
      <Variant id="0">
        {dynamicAppInstallBanners === "ON" && origin === 'header' ? <div id="dynamicBanner" className={cx(id === 'homepageBanner' ? '' : 'stickyBanner', 'placeholderBanner')}><React.Suspense fallback={null}><BarCarousel>
          {carouselBanner?.map(({ bannerImage = '', isAppInstallBanner = false, redirectionUrl = '' }) => <>
            <img className={cx('dynamicBanner')} src={replaceWithJioCDN(bannerImage)} alt='Install or Open Ajio app banner' onClick={() => {
              if (isAppInstallBanner) {
                triggerApp(appConfig, pagetype, 'topnav', appsFlyerConfig)
              } else {
                window.location.href = redirectionUrl;
              }
            }} />
          </>)}
          </BarCarousel></React.Suspense>
           </div>
         : <>
         <section
          id={id}
          className={cx(
            'appInstallSection',
            'flexCenterSticky',
            'grad_home',
            containerClass,
            impressionId
          )}
        >
          <CrossIcon sisIconColor="#202020" crossClass={cx('closeIcon')} onClick={handleClose} />
          <div className={cx('stickyBannerImage')}>
            <Image src={`${imgPath}/${image}`} className={cx('categoryImage')} alt='Ajio App image'/>
          </div>

          <main className={cx('mainContent')}>
            <div className={cx('stickyBannerHeader')}>
              <Text variant="T2" weight="bold">
                {isNewUser ? newUserHeaderText : oldUserHeaderText}
              </Text>
            </div>
            <div className={cx('appInstallSubheader')}>
              <RotatingText textArray={subtexts} customClass={cx('stickyHeaderSubText')} />
            </div>
          </main>
          <Button
            variant="primary"
            size="sm"
            btnLabel={isAppInstall ? 'Use App' : 'Get App'}
            customClass={cx('stickyBannerButton')}
            onClick={() => triggerApp(appConfig, pagetype, 'topnav', appsFlyerConfig)}
            ariaLabel={isAppInstall ? 'Use App' : 'Get App'}
          />
         </section>
         </> 
        }
      </Variant>
      <Variant id="1">{null}</Variant>
    </Feature>
  );
};

export default connector(StickyBanner);
